import { Select, Spin, Form } from "antd";
import { useState, useMemo, useEffect, useRef, useCallback } from "react";
import debounce from "lodash/debounce";
import { searchVendorsPaged } from "../../../../services/vendorService";

const SalesPersonSelect = () => {
    const [options, setOptions] = useState([]);
    const [fetching, setFetching] = useState(false);
    const pageRef = useRef(1);
    const searchRef = useRef("");
    const [hasMore, setHasMore] = useState(true);

    const loadVendors = useCallback(async (searchValue, pageValue = 1) => {
        if (fetching) return;

        setFetching(true);

        const { data, total } = await searchVendorsPaged({
            search: searchValue,
            page: pageValue,
            pageSize: 10,
        });

        const newOptions = data.map(v => ({
            label: `${v.value} - ${v.label}`,
            value: v.value,
        }));

        setOptions(prev => {
            // si es primera página reset total
            if (pageValue === 1) {
                return newOptions;
            }

            // si es scroll acumular
            const map = new Map();

            [...prev, ...newOptions].forEach(opt => {
                map.set(opt.value, opt);
            });

            return Array.from(map.values());
        });

        setHasMore(pageValue * 10 < total);
        setFetching(false);
    }, [fetching]);

    const debouncedSearch = useMemo(
        () =>
            debounce((value) => {
                searchRef.current = value;
                pageRef.current = 1;
                setOptions([]);
                loadVendors(value, 1);
            }, 300),
        [loadVendors]
    );

    const handleSearch = (value) => {
        debouncedSearch(value);
    };

    const handlePopupScroll = (e) => {
        const target = e.target;

        if (
            target.scrollTop + target.offsetHeight >= target.scrollHeight - 80 &&
            !fetching &&
            hasMore
        ) {
            pageRef.current += 1;
            loadVendors(searchRef.current, pageRef.current);
        }
    };

    useEffect(() => {
        return () => {
            debouncedSearch.cancel();
        };
    }, [debouncedSearch]);

    return (
        <Form.Item
            name="Salesperson_Code"
            label="Vendedor">
            <Select
                allowClear
                showSearch
                placeholder="Buscar vendedor"
                filterOption={false}
                onSearch={handleSearch}
                onChange={(value) => {
                    if (!value) {
                        debouncedSearch.cancel?.();
                        searchRef.current = "";
                        pageRef.current = 1;
                        loadVendors("", 1);
                    }
                }}
                options={options}
                notFoundContent={fetching ? <Spin size="small" /> : null}
                onPopupScroll={handlePopupScroll}
                style={{ width: "100%" }}
                onOpenChange={(open) => {
                    if (!open) {
                        // reseteo opciones al cerrar
                        setOptions([]);
                        pageRef.current = 1;
                        searchRef.current = "";
                        setHasMore(true);
                    }

                    if (open && options.length === 0) {
                        loadVendors("", 1);
                    }
                }}
            />
        </Form.Item>
    );
};

export default SalesPersonSelect;